// extracted by mini-css-extract-plugin
export default {"filter":"TasksGroupFilter_filter__dKv-n"};